export default "__VITE_ASSET__DuQQyrie__"